export default __webpack_public_path__ + "static/media/jonathan_king.08858967.jpg";